import axios from "axios";

// Your backend API URL
const API_BASE_URL = "https://uploadinvoice.dukanbuddy.com";

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,
});

export const extractInvoiceData = async (file, businessUuid) => {
  const formData = new FormData();
  formData.append("images", file); // Note: Your backend expects "images" not "file"

  try {
    console.log(`Uploading invoice to: /invoice/${businessUuid}/intake`);
    
    const response = await apiClient.post(`/invoice/${businessUuid}/intake`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
    console.log("API Response:", response.data);
    
    if (response.data && response.data.job_id) {
      // Now get the extracted result
      const result = await getInvoiceResult(businessUuid, response.data.job_id);
      return result;
    } else {
      throw new Error("No job_id received from server");
    }
  } catch (error) {
    console.error("API Error:", error);
    
    if (error.code === "ERR_NETWORK") {
      throw new Error(`Cannot connect to server at ${API_BASE_URL}. Please check if the backend is running.`);
    } else if (error.response) {
      throw new Error(`Server error: ${error.response.status} - ${error.response.data?.detail || error.message}`);
    } else {
      throw new Error(error.message || "Failed to extract invoice data");
    }
  }
};

export const getInvoiceResult = async (businessUuid, jobId) => {
  try {
    const response = await apiClient.get(`/invoice/${businessUuid}/result`, {
      params: { job_id: jobId }
    });
    
    console.log("Extraction result:", response.data);
    
    if (response.data && response.data.parsed_document) {
      // Transform backend response to frontend format
      const parsedDoc = response.data.parsed_document;
      const header = parsedDoc.header || {};
      const lines = parsedDoc.lines || [];
      
      // Transform to our frontend format
      const transformedData = {
        supplier: {
          name: header.vendor_name || "",
          gst: header.vendor_gstin || "",
          address: header.vendor_address || "",
          phone: header.vendor_phone || "",
        },
        invoiceNumber: header.invoice_no || "",
        invoiceDate: header.invoice_date || "",
        dueDate: header.due_date || "",
        items: lines.map(line => ({
          name: line.description || line.raw_description || "",
          quantity: line.qty || 1,
          unitPrice: line.unit_price || 0,
          price: line.unit_price || 0,
          total: line.line_total || 0,
          discount: line.discount_value || 0,
          discountType: "%",
          gst: line.tax_rate || 0,
          igst: header.intraState === false ? (line.tax_rate || 0) : 0,
          cgst: header.intraState !== false ? ((line.tax_rate || 0) / 2) : 0,
          sgst: header.intraState !== false ? ((line.tax_rate || 0) / 2) : 0,
          hsn: line.hsn || "",
        })),
        subtotal: header.subtotal || 0,
        totalAmount: header.grand_total || 0,
        taxAmount: header.tax_total || 0,
        additionalCharges: [],
        discounts: header.discount ? [{
          description: "Discount",
          amount: header.discount,
          type: "fixed"
        }] : []
      };
      
      return {
        success: true,
        data: transformedData,
        job_id: jobId,
        raw_response: response.data
      };
    } else {
      throw new Error("No parsed document in response");
    }
  } catch (error) {
    console.error("Error getting result:", error);
    throw new Error("Failed to get extraction result");
  }
};

export const matchInvoiceToProducts = async (businessUuid, jobId) => {
  const formData = new FormData();
  formData.append("job_id", jobId);
  
  try {
    const response = await apiClient.post(`/invoice/${businessUuid}/match`, formData);
    return response.data;
  } catch (error) {
    console.error("Match error:", error);
    throw new Error("Failed to match invoice to products");
  }
};

export const postInvoiceToBuy = async (businessUuid, jobId, warehouseId = null, addNewProducts = true, updateExisting = false) => {
  const formData = new FormData();
  formData.append("job_id", jobId);
  if (warehouseId) formData.append("warehouse_id", warehouseId);
  formData.append("add_new_products", addNewProducts.toString());
  formData.append("update_existing", updateExisting.toString());
  
  try {
    const response = await apiClient.post(`/invoice/${businessUuid}/post`, formData);
    return response.data;
  } catch (error) {
    console.error("Post error:", error);
    throw new Error("Failed to post invoice to buy");
  }
};